import engine from 'store/src/store-engine';
import sessionStorages from 'store/storages/sessionStorage';
import localStorages from 'store/storages/localStorage';
import plugins from 'store/plugins/expire';

export const sessionStore = engine.createStore(sessionStorages, plugins);
export const localStore = engine.createStore(localStorages, plugins);
